// Packages
import React from "react";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import moment from "moment";

// Icons
import CalendarIcon from "./../../../Assets/images/calendar.svg";
import DeleteIcon from "./../../../Assets/images/delete.svg";

// Components
import Date from "./../../../Components/FormControl/Date/Date";
import Select from "./../../../Components/FormControl/Select/Select";

// SCSS
import styles from "./index.module.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddClockDay = ({
  showModal,
  employeeList,
  clockDay,
  setClockDay,
  handleCancelClick,
  handleSubmitClick,
}) => {
  const handleTimeChange = (index, type, time) => {
    let clockTime = [...clockDay.clock_time];
    // the picker hands back a moment, a typed entry only the raw string
    const punchTime = moment.isMoment(time) ? time : moment(time, "hh:mm A");

    clockTime[index] = {
      ...clockTime[index],
      [type]: punchTime.isValid() ? punchTime.format("hh:mm A") : "",
    };
    setClockDay({ ...clockDay, clock_time: clockTime });
  };

  const handleAddPunch = (event) => {
    event.preventDefault();

    setClockDay({
      ...clockDay,
      clock_time: [...clockDay.clock_time, { clock_in: "", clock_out: "" }],
    });
  };

  const handleRemovePunch = (index) => {
    setClockDay({
      ...clockDay,
      clock_time: clockDay.clock_time.filter((punch, punchIndex) => punchIndex !== index),
    });
  };

  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={handleCancelClick}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent className={`${styles.modalContent} px-0 py-0`}>
          <div className={`text-center ${styles.modalBody}`}>
            <h5 className={`mt-0 mb-3 text-center ${styles.modalTitle}`}>
              Add Missing Day
            </h5>

            <div className="row text-left">
              <div className="col-sm-6 col-xs-12">
                <Select
                  label="Employee"
                  value={clockDay.user_id}
                  onChange={(data) => setClockDay({ ...clockDay, user_id: data })}
                  options={employeeList.filter((employee) => employee.id !== 0)}
                  disabled={false}
                />
              </div>
              <div className="col-sm-6 col-xs-12">
                <Date
                  label="Date"
                  value={clockDay.date}
                  dateFormat="ddd MMM DD, YYYY"
                  type="date"
                  fieldIcon={CalendarIcon}
                  isTimeStamp={false}
                  onChange={(date) =>
                    setClockDay({
                      ...clockDay,
                      date: moment(date).format("ddd MMM DD, YYYY"),
                    })
                  }
                />
              </div>
            </div>

            <div className="my-4">
              <table className="table">
                <thead>
                  <tr>
                    <th className="text-left">Clock In</th>
                    <th className="text-left">Clock Out</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {clockDay.clock_time.map((punch, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-left time-box-padding">
                          <Date
                            parentClass="pt-0 mb-1"
                            className="change-time-model"
                            value={punch.clock_in}
                            type="time"
                            onChange={(time) => handleTimeChange(index, "clock_in", time)}
                          />
                        </td>
                        <td className="text-left time-box-padding">
                          <Date
                            parentClass="pt-0 mb-1"
                            className="change-time-model"
                            value={punch.clock_out}
                            type="time"
                            onChange={(time) => handleTimeChange(index, "clock_out", time)}
                          />
                        </td>
                        <td className="text-center">
                          {clockDay.clock_time.length > 1 && (
                            <img
                              style={{ cursor: "pointer" }}
                              src={DeleteIcon}
                              alt="delete"
                              onClick={() => handleRemovePunch(index)}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <a
              href="/"
              onClick={handleAddPunch}
              className="btn light-grey-btn d-inline-block mb-3 mr-2"
            >
              Add Punch
            </a>
            <a
              href="/"
              onClick={handleSubmitClick}
              className="btn gray-btn d-inline-block mb-3 mr-2"
            >
              Save
            </a>
            <a
              href="/"
              onClick={handleCancelClick}
              className="btn light-grey-btn d-inline-block mb-3"
            >
              Cancel
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default AddClockDay;
